import { render, staticRenderFns } from "./roleMember.vue?vue&type=template&id=686cca3e"
import script from "./roleMember.vue?vue&type=script&lang=js"
export * from "./roleMember.vue?vue&type=script&lang=js"
import style0 from "./roleMember.vue?vue&type=style&index=0&id=686cca3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports